import {ChangeDetectionStrategy, Component, input, signal} from '@angular/core';
import {Button} from 'primeng/button';
import {Observable, take} from 'rxjs';

@Component({
  selector: 'homey-submit-button',
  standalone: true,
  imports: [Button],
  templateUrl: './submit-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubmitButtonComponent {
  protected readonly loading = signal(false);
  public readonly label = input.required<string>();
  public readonly severity = input<
    'primary' | 'secondary' | 'success' | 'info' | 'warn' | 'danger' | 'help' | 'contrast'
  >('primary');
  public readonly size = input<'small' | 'large' | undefined>(undefined);
  public readonly disabled = input(false);
  public readonly submitFunction = input.required<() => Observable<unknown> | Promise<unknown>>();

  onClick() {
    if (this.loading() || this.disabled()) {
      return;
    }

    this.loading.set(true);
    const result = this.submitFunction()();
    if (result instanceof Observable) {
      // Errors are swallowed on purpose: the HTTP error interceptor already reports them to the
      // operator. Handling them here only clears the loading state.
      result.pipe(take(1)).subscribe({
        error: () => this.loading.set(false),
        complete: () => this.loading.set(false),
      });
    } else {
      // Same as above: the rejection has already been reported by the interceptor, so it is caught
      // here to keep it from surfacing again as an unhandled rejection.
      Promise.resolve(result)
        .catch(() => undefined)
        .finally(() => this.loading.set(false));
    }
  }
}
